// TEMP_GAVA_TEST_GATE: remove this card gate after the Gava flow is approved for all users.
export const GAVA_ALLOWED_CARD_NUM = "3999";

export const isGavaAllowedForCardNum = (belongToCardNum) => (
  String(belongToCardNum || "").trim() === GAVA_ALLOWED_CARD_NUM
);
